import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { useMemo, useState } from 'react'

import { ActionType } from 'store/useSettingsStore'

import { ITabProps } from '../../types'

import { IUseFormSignUpContent } from './types'

const useFormSignUpContent = ({
  hasAction,
  accType
}: IUseFormSignUpContent) => {
  const { t } = useTranslation(['actions', 'auth', 'inputs'])
  const router = useRouter()
  const [resetForm, setResetForm] = useState(0)

  const tabs: ITabProps[] = useMemo(() => {
    const candidate: ITabProps = {
      label: t('auth:signup.types.candidate'),
      value: 'Candidate'
    }
    if (hasAction === ActionType.Apply) {
      return [candidate]
    }

    return [
      candidate,
      {
        label: t('auth:signup.types.employer'),
        value: 'Organisation'
      }
    ]
  }, [hasAction, t])

  const descriptionTranslate = useMemo(
    () => (accType === 'Candidate' ? 'candidate' : 'company'),
    [accType]
  )

  return {
    t,
    tabs,
    router,
    resetForm,
    descriptionTranslate,
    setResetForm
  }
}

export default useFormSignUpContent
